import { Plugin } from "@nuxt/types"

const i18n: Plugin = ({ app, store }) => {
  if (app.i18n) {
    // beforeLanguageSwitch called right before setting a new locale
    // @ts-ignore - Nuxt does not have types for this...
    app.i18n.beforeLanguageSwitch = async (oldLocale, locale) => {
      // get the header elements with locale
      await store.dispatch('ui/environment/fetchEnv', { locale })
    }

    const messages = store.state.sitecoreI18n || {}
    // @ts-ignore - Nuxt does not have types for this...
    app.i18n.mergeLocaleMessage(app.i18n.locale, messages)
    // mergeLocaleMessage is purely a vue-i18n function, we need to persist the messages in store
    store.state.i18n.messages = {
      ...store.state.i18n.messages,
      ...messages
    }
  }
}

export default i18n
